<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('NAVIGATION.BOOKING_RESOURCE') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="openDialog()">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('BOOKING.RESOURCES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <booking-resources-list-filter @setFilters="setFilters" />
      <booking-resources-list
        :items="items"
        :meta="meta"
        :options.sync="options"
        @show="show"
      />
    </v-sheet>

    <v-dialog v-if="dialogCreate" v-model="dialogCreate" max-width="800px">
      <v-card flat dense>
        <v-card-title>
          {{ $t('ITEM.ADD') }} {{ $t('ITEM.NEW') }}
          {{ $t('BOOKING.RESOURCES.ITEM') }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <capacity-stepper @cancel="closeDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { isEmpty } from 'lodash';
import { mapActions, mapState } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import BookingResourcesList from '@/modules/booking_resources/components/BookingResourcesList';
import BookingResourcesListFilter from '@/modules/booking_resources/components/forms/BookingResourcesListFilter';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'BookingResourcesPage',

  components: {
    CapacityStepper: () =>
      import('@/modules/booking_resources/components/forms/CapacityStepper'),
    BookingResourcesList,
    BookingResourcesListFilter,
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  mixins: [errors, listOptions],

  data() {
    return {
      dialogCreate: false,
      error: null
    };
  },

  computed: {
    ...mapState('booking_resources', ['paginationOptions'])
  },

  mounted() {
    if (!isEmpty(this.$route.params)) {
      this.dialogCreate = this.$route.params.create_resource || false;
    }
  },

  methods: {
    ...mapActions('booking_resources', ['getItemsList']),

    show(item) {
      this.$router.push({
        name: 'booking-resources.show',
        params: { id: item.id }
      });
    },
    openDialog() {
      this.dialogCreate = true;
    },
    closeDialog() {
      this.dialogCreate = false;
    }
  }
};
</script>
